import React, {useEffect, useState} from 'react';
import {FaTrash, FaArrowLeft, FaPlus} from 'react-icons/fa';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {getInstitutesRequest} from "../redux/actions/jointPowersActions";
import {getEmployeeRequest} from "../redux/actions/employeeActions";
import {
    addEmploymentRequest,
    getEmploymentsRequest, removeEmploymentRequest,
    updateEmploymentsRequest
} from "../redux/actions/employmentActions";
import '../error.css'
import {toast} from "react-toastify";

const EmploymentForm = ({ contract, setCurrentStep, previousStep, submitButtonText }) => {
    const dispatch = useDispatch();
    const institutes = useSelector(state => state.jointPower.institutes);
    const isLoadingInstitutes = useSelector(state => state.jointPower.loading.getInstitutes);
    const employee = useSelector(state => state.employee.employee);
    const isLoadingEmployee = useSelector(state => state.employee.loading.getEmployee);
    const employments = useSelector(state => state.employment.employments);
    const isAddingEmployment = useSelector(state => state.employment.loading.addEmployment);
    const isRemovingEmployment = useSelector(state => state.employment.loading.removeEmployment);
    const isLoadingEmployments = useSelector(state => state.employment.loading.getEmployments);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors } } = useForm({ defaultValues: employments });
    const [employmentsError, setEmploymentsError] = useState('');

    useEffect(() => {
        if (!institutes.length && !isLoadingInstitutes) {
            dispatch(getInstitutesRequest());
        }
        if (contract.ID && !('ID' in employee) && !isLoadingEmployee) {
            dispatch(getEmployeeRequest({contractID: contract.ID}));
        }
        if (contract.ID && employee.ID && !employments.length && !isLoadingEmployments) {
            dispatch(getEmploymentsRequest({ contractID: contract.ID, employeeID: employee.ID }));
        }
    }, [dispatch, institutes, employments, employee, contract, isLoadingEmployments, isLoadingInstitutes, isLoadingEmployee]);

    useEffect(() => {
        reset(institutes);
    }, [institutes, reset]);

    useEffect(() => {
        //reset(employments);
    } , [employments, reset]);


    const onSubmit = data => {
        console.log(data);
        const updatedEmployments = employments.map((employment, index) => ({
            ...employment, // Behält alle bestehenden Eigenschaften von employment bei
            OrgUnitID: data.employments[index].OrgUnitID,
            JobTitle: data.employments[index].JobTitle,
            NumOfUnits: data.employments[index].NumOfUnits,
            UnitType: data.employments[index].UnitType,
            NumOfUnitsTeaching: data.employments[index].NumOfUnitsTeaching,
            UnitTypeTeaching: data.employments[index].UnitTypeTeaching,
            IsLeading: data.employments[index].IsLeading
        }));
        dispatch(updateEmploymentsRequest(updatedEmployments)); // Dispatch der Redux-Aktion mit den Formulardaten
        setCurrentStep();
    };

    const createEmployment = (employeeID) => {
        if (institutes.length && !isAddingEmployment) {
            dispatch(addEmploymentRequest({employeeID}))
        } else {
            setEmploymentsError('Es konnten keine Institute geladen werden. Bitte versuchen Sie es später erneut.');
        }
    };

    const dropEmployment = (employmentID) => {
        if (!isRemovingEmployment) {
            dispatch(removeEmploymentRequest({employmentID: employmentID}))
        }
    };

    if (!institutes.length) return (<div>Es konnten keine Institute geladen werden. Bitte versuchen Sie es später erneut.</div>);

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit(onSubmit)} className="contract-form">
                <div className="mb-3 form-field">
                    <label className="form-label">Beschäftigungen</label>
                    {employments.map((employment, index) => (
                        <div key={index} className="row mb-3" style={{paddingTop: "3.5vh"}}>
                            <div className="col-12">
                                <select {...register(`employments[${index}].OrgUnitID`)}
                                        defaultValue={employment.OrgUnitID}
                                        className="form-select">
                                    <option value="" disabled>Wählen Sie eine Organisationseinheit</option>
                                    {institutes.map((institute, i) => (
                                        <option key={i} value={institute.ID}>{institute.Name}</option>
                                    ))}
                                </select>
                                {errors.employments && errors.employments[index]?.OrgUnitID && (
                                    <p className="error-message">{errors.employments[index]?.OrgUnitID.message}</p>
                                )}
                            </div>
                            <div className="col-12" style={{paddingTop: "2vh"}}>
                                <input {...register(`employments[${index}].JobTitle`)}
                                       defaultValue={employment.JobTitle} type="text"
                                       className={`form-control `}
                                       placeholder="Bezeichnung der Stelle"/>
                                {errors.employments && errors.employments[index]?.JobTitle && (
                                    <p className="error-message">{errors.employments[index]?.JobTitle.message}</p>
                                )}
                            </div>
                            <div className="col-12" style={{paddingTop: "2vh"}}>Lehrend</div>
                            <div className="col-6">
                                <input {...register(`employments[${index}].NumOfUnitsTeaching`)}
                                       defaultValue={employment.NumOfUnitsTeaching} type="number" min="0" step="0.001"
                                       className={`form-control ${errors.employments?.[index]?.JobTitle ? 'error' : ''}`}
                                       placeholder="Anzahl der Einheiten"/>
                            </div>
                            <div className="col-6">
                                <select  {...register(`employments[${index}].UnitTypeTeaching`)}
                                         defaultValue={employment.UnitTypeTeaching} className="form-select">
                                    <option value="" disabled>Wählen Sie</option>
                                    <option value="WE">WE</option>
                                    <option value="STD">Std</option>
                                </select>
                            </div>
                            <div className="col-12" style={{paddingTop: "2vh"}}>Nicht Lehrend</div>
                            <div className="col-6">
                                <input {...register(`employments[${index}].NumOfUnits`)}
                                       defaultValue={employment.NumOfUnits} type="number" min="0" step="0.001"
                                       className={`form-control ${errors.employments?.[index]?.JobTitle ? 'error' : ''}`}
                                       placeholder="Anzahl der Einheiten"/>
                            </div>
                            <div className="col-6">
                                <select  {...register(`employments[${index}].UnitType`)}
                                         defaultValue={employment.UnitType} className="form-select">
                                    <option value="" disabled>Wählen Sie</option>
                                    <option value="WE">WE</option>
                                    <option value="STD">Std</option>
                                </select>
                            </div>
                            <div className="col-6" style={{paddingTop: "2vh"}}>
                                <div className="form-check">
                                    <input {...register(`employments[${index}].IsLeading`)}
                                           defaultChecked={employment.IsLeading}
                                           className="form-check-input"
                                           type="checkbox"/>
                                    <label className="form-check-label" htmlFor={`IsLeading-${index}`}>
                                        Personalführend
                                    </label>
                                </div>
                            </div>
                            <div className="col-6 mb-3" style={{paddingTop: "2vh", textAlign: "right"}}>
                                <FaTrash
                                    className="remove-icon"
                                    onClick={() => dropEmployment(employment.ID)}
                                    style={{cursor: 'pointer', color: 'red'}}
                                />
                            </div>
                        </div>
                    ))}
                    <hr/>
                    <div className="row mb-3">
                        <div className="col-12" style={{textAlign: "right"}}>
                            <div style={{marginTop: "1vh"}}>
                                <FaPlus
                                    className="add-icon"
                                    onClick={() => createEmployment(employee.ID)}
                                    style={{cursor: 'pointer', color: 'blue', fontSize: '1.5em'}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {employmentsError && <p className="error-message">{employmentsError}</p>}
                <div className="form-navigation-buttons">
                    {previousStep && (
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={previousStep}
                        >
                            <FaArrowLeft/> Zurück
                        </button>
                    )}
                    <button type="submit" className="btn btn-primary">{submitButtonText}</button>
                </div>
            </form>
        </div>
    );
};

export default EmploymentForm;